import './App.css';
import './performance-optimizations.css';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardLayout from './components/AdminDashboardLayout';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import SuperAdminDashboardPage from './pages/SuperAdminDashboardPage';
import SuperAdminLoginPage from './pages/SuperAdminLoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
const CustomerManagementPage = lazy(() => import('./pages/CustomerManagementPage'));
const CustomerJourneyPage = lazy(() => import('./pages/CustomerJourneyPage'));
const PublicInvestorDashboardPage = lazy(() => import('./pages/PublicInvestorDashboardPage'));


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Admin Portal Routes */}
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="admin/login" element={<AdminLoginPage />} />
        <Route path="super-admin/login" element={<SuperAdminLoginPage />} />
        <Route path="admin/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="admin/reset-password" element={<ResetPasswordPage />} />
        <Route path="investor/:token" element={
          <Suspense fallback={<div className="tab-loading" role="status">Loading dashboard...</div>}>
            <PublicInvestorDashboardPage />
          </Suspense>
        } />

        {/* Main Admin Dashboard - Shared by all admin roles (permissions handled internally) */}
        <Route element={<ProtectedAdminRoute><AdminDashboardLayout /></ProtectedAdminRoute>}>
          <Route path="admin/super-dashboard" element={<SuperAdminDashboardPage />} />
          <Route path="admin/dashboard" element={<Navigate to="/admin/super-dashboard" replace />} />
          <Route path="admin/customers" element={
            <Suspense fallback={<div className="tab-loading" role="status">Loading customers...</div>}>
              <CustomerManagementPage />
            </Suspense>
          } />
          <Route path="admin/customer/:id" element={
            <Suspense fallback={<div className="tab-loading" role="status">Loading customer...</div>}>
              <CustomerJourneyPage />
            </Suspense>
          } />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
